/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: 24,
        height: 21,
        viewBox: "0 0 24 21",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ _jsx(Path, {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3 0a3 3 0 0 0-3 3v14.25a3 3 0 0 0 3 3h17.89a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3zm7.91 8.63H8.98v-.66H6.41v3.98h2.57v-.67h1.93v1.33a1.3 1.3 0 0 1-1.28 1.33H5.77a1.3 1.3 0 0 1-1.29-1.33v-5.3c0-.74.58-1.33 1.29-1.33h3.86c.7 0 1.28.6 1.28 1.32zm9 0h-1.93v-.66h-2.57v3.98h2.57v-.67h1.93v1.33a1.3 1.3 0 0 1-1.29 1.33h-3.85a1.3 1.3 0 0 1-1.29-1.33v-5.3c0-.74.57-1.33 1.29-1.33h3.85c.72 0 1.29.6 1.29 1.32z",
            fill: "currentColor"
        })
    }));
};
export default SvgComponent;
